<template>
  <modal
    name="modal--logout"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="300"
    :height="'auto'"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div v-if="loading === false" class="w-full">
        <div class="text-center text-4xl font-normal tracking-tight">
          Logout
        </div>
        <div class="text-center text-2xl mb-6 font-normal tracking-tight">
          Are you sure?
        </div>
        <div class="flex flex-row justify-between mt-3">
          <button
            class="button focus:shadow-outline focus:outline-none"
            @click="cancel"
          >
            Cancel
          </button>
          <button
            class="button focus:shadow-outline focus:outline-none"
            @click="confirm"
          >
            Confirm
          </button>
        </div>
      </div>
      <div
        v-if="loading === true"
        class="text-center text-4xl font-extralight tracking-tight"
      >
        logging out...
      </div>
    </div>
  </modal>
</template>

<script>
import { to } from '@/utils.js'
export default {
  name: 'ModalLogout',
  computed: {
    loading() {
      return this.$store.state.config.loading
    }
  },
  methods: {
    hideModal: function () {
      this.$modal.hide('modal--logout')
    },
    cancel: function () {
      this.hideModal()
    },
    confirm: async function () {
      await to(this.$store.dispatch('user/logout'))
      this.hideModal()
      this.$modal.show('modal--login')
    }
  }
}
</script>
